import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button,
  List,
  ListItem,
  ListItemIcon,
  Divider,
  IconButton,
  useTheme,
  Chip,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import HistoryIcon from "@mui/icons-material/History";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import HomeIcon from "@mui/icons-material/Home";
import PhoneIcon from "@mui/icons-material/Phone";
import BadgeIcon from "@mui/icons-material/Badge";
import { Outlet, useNavigate } from "react-router-dom";
import useIPAddress from "../Utils/useIPAddress";
import { baseapi } from "../Environmentalurl";
import { entity_id, location, Platform } from "../Utils/Const";
import DashboardHeader from "../Dashboard/DashboardHeader";
import { useDispatch } from "react-redux";
import { clearUser } from "../Slice/authSlice";
import api from "../Utils/Api";

const SettingsPage = () => {
  const [profileUrl, setProfileUrl] = useState("");
  const navigate = useNavigate();
  const ip = useIPAddress();
  const dispatch = useDispatch();

  const [profileData, setProfileData] = useState({
    MobileNumber: "",
    AccountNo: "",
    Poiemail: "",
    MMID: "",
    NameOnCard: "",
  });

  useEffect(() => {
    if (!ip) return;
    const fetchProfileData = async () => {
      const mobile = sessionStorage.getItem("mobileNumber");
      const sessionid = sessionStorage.getItem("SessionID");
      if (!mobile) return;
      try {
        const response = await api.post(`${baseapi}/viewprofile`, {
          ReqType: "MT_User_ViewProfile",
          Mobilenumber: mobile,
          SessionID: sessionid,
          Platform,
          GeoLocation: location,
          MachineID: ip,
          EntityID: entity_id,
        });
        if (response.data.Response_Code === "1000") {
          const info = response.data.Info[0];
          setProfileData({
            MobileNumber: info.MobileNumber || "",
            AccountNo: info.AccountNo || "",
            Poiemail: info.Poiemail || "Not Available",
            IFSCCode: info.PDBankIFSC || "",
            MMID: info.MMID || "",
            NameOnCard: info.NameOnCard || "",
          });
        }
      } catch (error) {
        console.error("API Error:", error);
      }
    };
    fetchProfileData();
  }, [ip]);

  useEffect(() => {
    if (!ip) return;
    const mobileNumber = sessionStorage.getItem("mobileNumber");
    const SessionID = sessionStorage.getItem("SessionID");
    if (!mobileNumber || !SessionID) return;
    const fetchProfileImage = async () => {
      try {
        const response = await api.get(`${baseapi}/image`, {
          params: {
            mobileNumber,
            userSessionId: SessionID,
            entityId: entity_id,
          },
          headers: { userSessionid: SessionID },
        });
        if (
          response.data?.Response_Code === "1000" &&
          response.data?.ProfileURL
        ) {
          setProfileUrl(response.data.ProfileURL);
        }
      } catch (error) {
        console.error("Profile image API error:", error);
      }
    };
    fetchProfileImage();
  }, [ip]);

  const handleLogout = () => {
    // ✅ FIX: Preserve BOTH SessionWalletToken AND mobileNumber across logout.
    // mobileNumber is needed by the TPIN screen after re-login so the
    // loginwithtpin payload has a valid Mobilenumber to send.
    const walletToken = localStorage.getItem("SessionWalletToken");
    const mobileNumber = sessionStorage.getItem("mobileNumber");

    dispatch(clearUser());
    sessionStorage.clear();
    localStorage.clear();

    // Restore the two keys that must survive logout
    if (walletToken) {
      localStorage.setItem("SessionWalletToken", walletToken);
    }
    if (mobileNumber) {
      // Keep it available for the TPIN screen even when loginMeta is null
      sessionStorage.setItem("mobileNumber", mobileNumber);
    }

    window.location.href = "/";
  };

  const handleItemClick = (text) => {
    const routes = {
      "Citizen Info": "/profile-settings/citizeninfo",
      "Add/Update Email": "/profile-settings/UpdateEmail",
      "Wallet Usage Limits": "/profile-settings/wallet-usage-limit",
      "Update Bank Details": "/profile-settings/updatebankdetails",
      "Link PAN Number": "/profile-settings/linkpan",
      TPIN: "/profile-settings/tpin",
      "Wallet Ledger Statement": "/profile-settings/transactionhistory",
      "Wallet Closure Request": "/profile-settings/walletclouserreq",
      "Contact Us": "/profile-settings/Contact-support",
    };
    if (routes[text]) navigate(routes[text]);
  };

  const listSections = [
    {
      title: "Account Settings",
      color: "#16a34a",
      items: [
        {
          icon: <AccountCircleOutlinedIcon />,
          text: "Citizen Info",
          subtext: "View & update personal details",
          color: "#16a34a",
          bg: "#f0fdf4",
        },
        {
          icon: <EmailOutlinedIcon />,
          text: "Add/Update Email",
          subtext: "Manage your email address",
          color: "#0ea5e9",
          bg: "#f0f9ff",
        },
        {
          icon: <AccountBalanceWalletOutlinedIcon />,
          text: "Update Bank Details",
          subtext: "Update bank account information",
          color: "#7c3aed",
          bg: "#faf5ff",
        },
      ],
    },
    {
      title: "Wallet Management",
      color: "#d97706",
      items: [
        {
          icon: <CreditCardIcon />,
          text: "Link PAN Number",
          subtext: "Connect your PAN card",
          color: "#d97706",
          bg: "#fffbeb",
        },
        {
          icon: <LockOutlinedIcon />,
          text: "TPIN",
          subtext: "Set or change transaction PIN",
          color: "#ef4444",
          bg: "#fef2f2",
        },
        {
          icon: <SettingsOutlinedIcon />,
          text: "Wallet Usage Limits",
          subtext: "Modify transaction limits",
          color: "#f59e0b",
          bg: "#fffbeb",
        },
        {
          icon: <HistoryIcon />,
          text: "Wallet Ledger Statement",
          subtext: "Download transaction history",
          color: "#0ea5e9",
          bg: "#f0f9ff",
        },
      ],
    },
    {
      title: "Wallet Services",
      color: "#ef4444",
      items: [
        {
          icon: <InfoOutlinedIcon />,
          text: "Wallet Closure Request",
          subtext: "Request to close your wallet",
          color: "#ef4444",
          bg: "#fef2f2",
        },
      ],
    },
    {
      title: "Support",
      color: "#6b7280",
      items: [
        {
          icon: <SupportAgentOutlinedIcon />,
          text: "Contact Us",
          subtext: "Get in touch with support",
          color: "#16a34a",
          bg: "#f0fdf4",
        },
        {
          icon: <ExitToAppOutlinedIcon />,
          text: "Logout",
          subtext: "Sign out of your account",
          color: "#ef4444",
          bg: "#fef2f2",
          onClick: handleLogout,
        },
      ],
    },
  ];

  const initial = profileData.NameOnCard?.charAt(0)?.toUpperCase() || "U";

  return (
    <>
      <DashboardHeader />
      <Box
        sx={{
          bgcolor: "#f8fafc",
          minHeight: "100vh",
          py: { xs: 2, md: 3 },
          px: { xs: 2, md: 4 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 3,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: { xs: 20, md: 24 },
                color: "#111827",
              }}
            >
              Profile & Settings
            </Typography>
            <Typography sx={{ fontSize: 13, color: "#6b7280" }}>
              Manage your account and preferences
            </Typography>
          </Box>
          <Button
            variant="outlined"
            startIcon={<HomeIcon />}
            onClick={() => navigate("/dashboard")}
            sx={{
              borderColor: "#e5e7eb",
              color: "#374151",
              fontSize: 13,
              "&:hover": {
                borderColor: "#16a34a",
                color: "#16a34a",
                bgcolor: "#f0fdf4",
              },
            }}
          >
            Dashboard
          </Button>
        </Box>

        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 4 }} item xs={12} md={4}>
            <Card
              sx={{
                borderRadius: 3,
                border: "1px solid #f0f0f0",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  background: "linear-gradient(135deg,#15803d,#22c55e)",
                  p: 3,
                  textAlign: "center",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: -20,
                    left: -20,
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    bgcolor: "rgba(255,255,255,0.08)",
                  }}
                />
                <Avatar
                  sx={{
                    width: 72,
                    height: 72,
                    mx: "auto",
                    mb: 1.5,
                    fontSize: 28,
                    fontWeight: 800,
                    bgcolor: "rgba(255,255,255,0.2)",
                    color: "white",
                    border: "3px solid rgba(255,255,255,0.3)",
                  }}
                >
                  {profileUrl ? (
                    <img
                      src={profileUrl}
                      alt="Profile"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    initial
                  )}
                </Avatar>
                <Typography
                  sx={{ fontWeight: 800, fontSize: 17, color: "white" }}
                >
                  {profileData.NameOnCard || "User"}
                </Typography>
                <Chip
                  label="Active Account"
                  size="small"
                  sx={{
                    mt: 0.5,
                    bgcolor: "rgba(255,255,255,0.15)",
                    color: "white",
                    fontWeight: 600,
                    fontSize: 11,
                  }}
                />
              </Box>
              <CardContent sx={{ p: 2.5 }}>
                {[
                  {
                    icon: <PhoneIcon sx={{ fontSize: 15 }} />,
                    label: "Mobile",
                    value:
                      profileData.MobileNumber ||
                      sessionStorage.getItem("mobileNumber"),
                  },
                  {
                    icon: <EmailOutlinedIcon sx={{ fontSize: 15 }} />,
                    label: "Email",
                    value: profileData.Poiemail,
                  },
                  {
                    icon: (
                      <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 15 }} />
                    ),
                    label: "Account No",
                    value: profileData.AccountNo || "—",
                  },
                  {
                    icon: <BadgeIcon sx={{ fontSize: 15 }} />,
                    label: "MMID",
                    value: profileData.MMID || "—",
                  },
                ].map((item) => (
                  <Box
                    key={item.label}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      py: 1.2,
                      borderBottom: "1px solid #f9fafb",
                      "&:last-child": { borderBottom: "none" },
                    }}
                  >
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: "8px",
                        bgcolor: "#f0fdf4",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#16a34a",
                        flexShrink: 0,
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography
                        sx={{
                          fontSize: 10,
                          color: "#9ca3af",
                          fontWeight: 500,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "#111827",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.value}
                      </Typography>
                    </Box>
                  </Box>
                ))}
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 2,
                    background: "linear-gradient(135deg,#16a34a,#22c55e)",
                    borderRadius: 2,
                  }}
                  onClick={() => navigate("/profile-settings/citizeninfo")}
                >
                  View Full Profile
                </Button>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 8 }} item xs={12} md={8}>
            {listSections.map((section, i) => (
              <Card
                key={i}
                sx={{
                  borderRadius: 3,
                  border: "1px solid #f0f0f0",
                  mb: 2,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    px: 2.5,
                    py: 1.5,
                    borderBottom: "1px solid #f9fafb",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 6,
                      height: 20,
                      borderRadius: 3,
                      bgcolor: section.color,
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: 12,
                      color: "#6b7280",
                      textTransform: "uppercase",
                      letterSpacing: 0.8,
                    }}
                  >
                    {section.title}
                  </Typography>
                </Box>
                <List disablePadding sx={{ px: 1, py: 1 }}>
                  {section.items.map((item, index) => (
                    <ListItem
                      button
                      key={index}
                      onClick={() => {
                        if (item.onClick) {
                          item.onClick();
                          return;
                        }
                        handleItemClick(item.text);
                      }}
                      sx={{
                        borderRadius: 2,
                        mb: 0.5,
                        px: 1.5,
                        py: 1.2,
                        cursor: "pointer",
                        "&:hover": { bgcolor: "#f9fafb" },
                        transition: "all 0.15s",
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 44 }}>
                        <Box
                          sx={{
                            width: 36,
                            height: 36,
                            borderRadius: "10px",
                            bgcolor: item.bg,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: item.color,
                          }}
                        >
                          {React.cloneElement(item.icon, {
                            sx: { fontSize: 18 },
                          })}
                        </Box>
                      </ListItemIcon>
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            color:
                              item.text === "Logout" ? "#ef4444" : "#111827",
                          }}
                        >
                          {item.text}
                        </Typography>
                        {item.subtext && (
                          <Typography
                            sx={{ fontSize: 11, color: "#9ca3af", mt: 0.2 }}
                          >
                            {item.subtext}
                          </Typography>
                        )}
                      </Box>
                      <ArrowForwardIosIcon
                        sx={{ fontSize: 12, color: "#d1d5db" }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Card>
            ))}
          </Grid>
        </Grid>
      </Box>
      <Outlet />
    </>
  );
};

export default SettingsPage;